function extractSectionId(element) {
  element = element.classList.contains("shopify-section") ? element : element.closest(".shopify-section");
  return element.id.replace("shopify-section-", "");
}

// Recently Viewed Products
var _isLoaded, searchQueryString_get, loadProducts_fn, initCarousel_fn, handleResize_fn;
var RecentlyViewedProducts = class extends HTMLElement {
  connectedCallback() {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(loadProducts_fn.bind(this), { timeout: 1500 });
    } else {
      loadProducts_fn.call(this);
    }
    
    // Bind resize handler
    this.boundHandleResize = handleResize_fn.bind(this);
    window.addEventListener('resize', this.boundHandleResize);
  }
  disconnectedCallback() {
    // Clean up resize listener
    if (this.boundHandleResize) {
      window.removeEventListener('resize', this.boundHandleResize);
    }
  }
};
  _isLoaded = new WeakMap();
  searchQueryString_get = function() {
    const items = new Set(JSON.parse(localStorage.getItem("theme:recently-viewed-products") || "[]"));
    if (this.hasAttribute("exclude-id")) {
      items.delete(parseInt(this.getAttribute("exclude-id")));
    }
    return Array.from(items.values(), (item) => `id:${item}`).slice(0, parseInt(this.getAttribute("products-count"))).join(" OR ");
  };
  loadProducts_fn = async function() {
    if (_isLoaded.has(this) && _isLoaded.get(this)) {
      return;
    }
    _isLoaded.set(this, true);
    const section = this.closest(".shopify-section"), url = `${Shopify.routes.root}search?type=product&q=${searchQueryString_get.call(this)}&section_id=${extractSectionId(section)}`, response = await fetch(url, { priority: "low" });
    const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"), recentlyViewedProductsElement = tempDiv.querySelector("recently-viewed-products");
    if (recentlyViewedProductsElement.childElementCount > 0) {
      this.replaceChildren(...document.importNode(recentlyViewedProductsElement, true).childNodes);
      
      // Initialize carousel on mobile after products load
      initCarousel_fn.call(this);
    } else {
      section.remove();
    }
  };
  initCarousel_fn = function() {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
      console.warn('jQuery or Slick not loaded yet');
      return;
    }
    
    const $flex = jQuery(this).find('.content-related .flex');
    
    if (!$flex.length) return;
    
    const ww = window.innerWidth;
    
    if (ww <= 767) {
      if (!$flex.hasClass("slick-initialized")) {
        $flex.slick({
          dots: false,
          arrows: true,
          variableWidth: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          adaptiveHeight: true,
          prevArrow: '.prev-arrow',
          nextArrow: '.next-arrow',
        });
      }
    } else {
      if ($flex.hasClass("slick-initialized")) {
        $flex.slick("unslick");
      }
    }
};
handleResize_fn = function() {
  initCarousel_fn.call(this);
};
if (!window.customElements.get("recently-viewed-products")) {
  window.customElements.define("recently-viewed-products", RecentlyViewedProducts);
}

// Image Text Carousel
var ImageTextCarousel = class extends HTMLElement {
  connectedCallback() {
    // Wait for DOM to be fully ready and jQuery/Slick to be available
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => this.initCarousel(), 100);
      });
    } else {
      setTimeout(() => this.initCarousel(), 100);
    }
    
    // Bind resize handler
    this.boundHandleResize = this.handleResize.bind(this);
    window.addEventListener('resize', this.boundHandleResize);
  }
  disconnectedCallback() {
    // Clean up resize listener
    if (this.boundHandleResize) {
      window.removeEventListener('resize', this.boundHandleResize);
    }
  }
  initCarousel() {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
      console.warn('jQuery or Slick not loaded yet');
      return;
    }
    
    const $carousel = jQuery(this).find('.image-text-carousel__items');
    
    if (!$carousel.length) return;
    
    // Ensure carousel element is in the DOM
    if (!$carousel.parent().length) {
      console.warn('Carousel not in DOM, retrying...');
      setTimeout(() => this.initCarousel(), 100);
      return;
    }
    
    // Ensure carousel has items
    if (!$carousel.children().length) {
      console.warn('Carousel has no items, skipping initialization');
      return;
    }
    
    const ww = window.innerWidth;
    const isMobile = ww <= 767;
    
    // Get arrow containers
    const $mobileArrows = jQuery(this).find('.image-text-carousel__arrows--mobile');
    const $desktopArrows = jQuery(this).find('.image-text-carousel__arrows--desktop');
    
    // Move arrows to mobile container on mobile, back to desktop on desktop
    if (isMobile) {
      // Move arrows to mobile container if not already there
      if ($desktopArrows.find('.prev-arrow').length) {
        const $prevArrow = $desktopArrows.find('.prev-arrow');
        const $nextArrow = $desktopArrows.find('.next-arrow');
        $mobileArrows.append($prevArrow);
        $mobileArrows.append($nextArrow);
      }
    } else {
      // Move arrows back to desktop container if not already there
      if ($mobileArrows.find('.prev-arrow').length) {
        const $prevArrow = $mobileArrows.find('.prev-arrow');
        const $nextArrow = $mobileArrows.find('.next-arrow');
        $desktopArrows.append($prevArrow);
        $desktopArrows.append($nextArrow);
      }
    }
    
    // Get arrows from the correct container
    const $arrowContainer = isMobile ? $mobileArrows : $desktopArrows;
    const $prevArrow = $arrowContainer.find('.prev-arrow');
    const $nextArrow = $arrowContainer.find('.next-arrow');
    
    if (!$prevArrow.length || !$nextArrow.length) {
      console.warn('Arrow buttons not found, retrying...');
      setTimeout(() => this.initCarousel(), 100);
      return;
    }
    
    // If carousel is already initialized, unbind events and unslick
    if ($carousel.hasClass("slick-initialized")) {
      $carousel.off('afterChange');
      $carousel.slick("unslick");
    }
    
    // Initialize Slick with arrows
    $carousel.slick({
      dots: false,
      arrows: true,
      variableWidth: false,
      slidesToShow: 2.5,
      slidesToScroll: 1,
      centerMode: false,
      infinite: false,
      adaptiveHeight: false,
      prevArrow: $prevArrow,
      nextArrow: $nextArrow,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1.1
          }
        }
      ],
    });
    
    // Function to update arrow states
    const updateArrows = () => {
      const currentSlide = $carousel.slick('slickCurrentSlide');
      const slideCount = $carousel.slick('getSlick').slideCount;
      const slidesToShow = $carousel.slick('slickGetOption', 'slidesToShow');
      
      // Check if we're at the first slide
      if (currentSlide === 0) {
        $prevArrow.prop('disabled', true);
      } else {
        $prevArrow.prop('disabled', false);
      }
      
      // Check if we're at the last slide (accounting for slidesToShow)
      if (currentSlide + slidesToShow >= slideCount) {
        $nextArrow.prop('disabled', true);
      } else {
        $nextArrow.prop('disabled', false);
      }
    };
    
    // Update arrows on init and after every slide change
    updateArrows();
    $carousel.on('afterChange', updateArrows);
  }
  handleResize() {
    this.initCarousel();
  }
};
if (!window.customElements.get("image-text-carousel")) {
  window.customElements.define("image-text-carousel", ImageTextCarousel);
}

// js/common/product/quick-add.js
var ProductQuickAdd = class extends HTMLElement {
  #scopeFromPassed = false;
  #scopeToReached = false;
  #intersectionObserver = new IntersectionObserver(this._onObserved.bind(this));
  connectedCallback() {
    const form = document.getElementById(this.getAttribute("form"));
    this._scopeFrom = form.querySelector(".main-product__buy-buttons");
    this._scopeTo = document.querySelector("#footer");
    if (!this._scopeFrom || !this._scopeTo) {
      return;
    }
    this.#intersectionObserver.observe(this._scopeFrom);
    this.#intersectionObserver.observe(this._scopeTo);
  }
  disconnectedCallback() {
    this.#intersectionObserver.disconnect();
  }
  _onObserved(entries) {
    entries.forEach((entry) => {
      if (entry.target === this._scopeFrom) {
        this.#scopeFromPassed = entry.boundingClientRect.bottom < 0;
      }
      if (entry.target === this._scopeTo) {
        this.#scopeToReached = entry.isIntersecting;
      }
    });
    this.classList.toggle("is-visible", this.#scopeFromPassed && !this.#scopeToReached);
  }
};
if (!window.customElements.get("product-quick-add")) {
  window.customElements.define("product-quick-add", ProductQuickAdd);
}
